import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { RouterError } from '../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../app/spaces/SpacesSiteUrls';
import { LensSubspaceName } from '../app/state/SpaceInfo';
import { ReactDirectiveProps } from '../ts/directives/reactDirectiveFactory';
import { LensSpaceProvider, LensSpaceProviderProps } from './LensSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
}
export interface LensRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface LensSpaceRouterProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

export class LensSpaceRouter extends React.Component<LensSpaceRouterProps> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.lensPath(':id')} render={this.provider('askData')} />
        <Route exact path={this.props.urls.lensUsageAnalyticsPath(':id')} render={this.provider('usageAnalytics')}/>
        <Route render={this.error} />
      </Switch>
    );
  }

  private provider = (subspaceName: LensSubspaceName): (props: LensRouteComponentProps) => JSX.Element => {
    return (props: LensRouteComponentProps): JSX.Element => {
      const lensSpaceProviderProps: LensSpaceProviderProps = {
        siteName: this.props.siteName,
        subspaceName,
        lensId: props.match.params.id,
        routeLocationSearch: props.location.search,
        routeLocationPath: props.location.pathname,
        urls: this.props.urls,
      };

      return <LensSpaceProvider {...lensSpaceProviderProps} />;
    };
  }

  private error = (): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }
}
